<template>
  <div class="sw-time" :class="getClassName()">
    <div class="num-content">
      <span class="num h-num">{{ hour }}</span
      >时
    </div>
    <div class="num-content">
      <span class="num m-num">{{ minute }}</span
      >分
    </div>
    <div class="num-content">
      <span class="num s-num">{{ second }}</span
      >秒
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCountDown",
  props: {
    countDownNum: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    className: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      hour: "00",
      minute: "00",
      second: "00",
    };
  },
  created() {
    this.beginCountDown();
  },
  methods: {
    fixedTime(time) {
      if (time < 10) {
        return "0" + time;
      }
      return time + "";
    },
    beginCountDown() {
      const endDate = new Date(this.countDownNum).getTime();
      const curDate = new Date().getTime();
      const totalSeconds = parseInt((endDate - curDate) / 1000);
      if (totalSeconds >= 0) {
        this.hour = this.fixedTime(Math.floor(totalSeconds / 60 / 60));
        this.minute = this.fixedTime(Math.floor((totalSeconds / 60) % 60));
        this.second = this.fixedTime(Math.floor(totalSeconds % 60));
        const self = this;
        setTimeout(() => {
          self.beginCountDown();
        }, 1000);
      }
    },
    getClassName() {
      let className = {};
      if (this.className && this.className.length > 0) {
        className[this.className] = true;
      }
      return className;
    },
  },
};
</script>

<style lang="less" scoped>
.sw-time {
  .num-content {
    display: inline-block;
		margin-bottom: 4px;
    .num {
      color: inherit;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>